import config from 'init/config';
import { fRequest } from 'utilities/api';

export const api_updateOrderStatus = (orderToken, newStatus) =>
  fRequest(`${config.buckRootUrl}/api/order/${orderToken}/cart-quote-switch/`, {
    method: 'POST',
    data: { desired_status: newStatus }
  });
